import { render, staticRenderFns } from "./AreaTree.vue?vue&type=template&id=74423ab6&scoped=true"
import script from "./AreaTree.vue?vue&type=script&lang=js"
export * from "./AreaTree.vue?vue&type=script&lang=js"
import style0 from "./AreaTree.vue?vue&type=style&index=0&id=74423ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74423ab6",
  null
  
)

export default component.exports